export const TableColumn = [     
    { data: '', Title: '#', width: 20, position: 1 },
    { data: '', Title: 'Abbreviation', position: 3 },
    { data: '', Title: 'Name', position: 2 },
    { data: '', Title: 'Created Date', position: 4 },
    { data: '', Title: 'Action', width:100, position: 5}
];